import api from '@/services/api'

import Auth from '../auth'
import { apiErrorHandler } from '../utils/apiErrors'

const NOTIFICATION_ENDPOINT = 'notifications/'

export default class NotificationAPI {
  /**
   * Instantiate a new `NotificationAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `NotificationAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new NotificationAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  markAllAsRead() {
    const url = `${NOTIFICATION_ENDPOINT}mark-all-as-read/`

    const promise = this.client.post(url)
    return promise
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Update notification API error' }))
  }

  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = NOTIFICATION_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }

    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'Notification API error' }))
  }
}
